import React from 'react';
import { TypographyWithWarning, TypographyProps } from 'components/v2';

interface FormFieldContactsArchivedProps extends TypographyProps {
  label: string;
}

export const FormFieldContactsArchived: React.FC<FormFieldContactsArchivedProps> = ({ label, variant }) => (
  <TypographyWithWarning variant={variant || 'caption'} color="secondary" inline gutterBottom paragraph>
    {label}
  </TypographyWithWarning>
);
